export const DEPOSIT_GUIDE_HINTS = {
  selectCoin: {
    id: "select-coin",
    step: 2,
    title: "Select Coin",
    description:
      "Choose the cryptocurrency you'd like to buy or deposit to continue your journey with Monfi.",
    position: "left",
    secondaryAction: "skip",
    inlineOnMobile: true,
    mobilePlacement: "top",
  },
  selectNetwork: {
    id: "select-network",
    step: 3,
    title: "Select Network",
    description:
      "Choose the correct blockchain network to ensure your transaction is fast, secure, and successful.",
    position: "right",
    secondaryAction: "skip",
    inlineOnMobile: true,
    mobilePlacement: "top",
  },
  copyAddress: {
    id: "copy-address",
    step: 4,
    title: "Copy Address",
    description:
      "Copy your unique wallet address and use it to securely transfer crypto into your Monfi account.",
    position: "right",
    primaryAction: "done",
    secondaryAction: "buyCrypto",
    showPointer: true,
    inlineOnMobile: true,
    mobilePlacement: "top",
  },
};
